<ng-template #template>
  <ng-container [formGroup]="form">
    <h3 class="drawer-title">Informations</h3>

    <div class="form-sct-container">
      <input formControlName="id" type="hidden" />

      <pr-input-date
        formControlName="startDate"
        label="Date de début"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input-date
        formControlName="endDate"
        label="Date de fin"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input label="Type de montant" [derrors]="derrors">
        <mat-select formControlName="connaissance">
          @for (connaissance of connaissances; track connaissance) {
            <mat-option [value]="connaissance.id">
              {{ connaissance.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input label="Montant" [suffix]="amountSuffix()" [derrors]="derrors">
        <input formControlName="amount" type="text" />
      </pr-input>

      <pr-input label="Frais réels" suffix="€/an" [derrors]="derrors">
        <input formControlName="fraisReel" type="text" />
      </pr-input>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngTemplateOutlet="template"></ng-container>
